export default __webpack_public_path__ + "d54e03874ef5af85ae1758de03816809.svg";